import Checkbox from '@mui/material/Checkbox';
import styled from 'styled-components';

export const StyledCheckbox = styled(Checkbox)`
  margin: 0px !important;
  padding: 0px !important;
  margin-right: 5px !important;

  & span {
    padding: 0px !important;
  }
`;
